// src/components/public/FooterNavList.jsx
import SmartLink from "components/atoms/SmartLink"

export default function FooterNavList({ navList, isNextUrl }) {
   return (
      <ul className="list-none space-y-4">
         {navList.map((navItem) => (
            <li key={navItem.id}>
               <SmartLink
                  className="text-white no-underline hover:text-lighter"
                  isNextUrl={isNextUrl !== undefined ? isNextUrl : navItem?.isNextUrl}
                  href={navItem.path}>
                  {navItem.name}
               </SmartLink>
            </li>
         ))}
      </ul>
   )
}
